export type SvgEl = React.HTMLAttributes<HTMLOrSVGElement>;

export const IconCirclePlus: React.FC<SvgEl> = (props: SvgEl) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
      <path d="M40 0a40 40 0 1040 40A40 40 0 0040 0zm0 76.7A36.7 36.7 0 1176.7 40 36.8 36.8 0 0140 76.7zm1.7-54.2h-3.4v15.7H22.7v3.3h15.6v16h3.4v-16h15.6v-3.3H41.7z" />
    </svg>
  );
};
